import React, { useEffect, useState } from "react";
import {
  Box,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  DownloadPurchaseHistoryReport,
  DownloadPurchaseHistoryInvoice,
  GetPurchaseHistory,
} from "../../service/settings.request";
import { PuffLoader } from "react-spinners";
import { useAuthUser } from "react-auth-kit";
// Icons
/* import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'; */
import moment from "moment";
import successIcon from "../../../../../assets/images/successIcon.svg";
import failedIcon from "../../../../../assets/images/failedIcon.svg";
import pendingIcon from "../../../../../assets/images/pendingIcon.svg";
import DownloadIcon from "@mui/icons-material/Download";
import download from "../../../../../assets/images/download.svg";
import resend from "../../../../../assets/images/resend.svg";
import copyPayment from "../../../../../assets/images/copy-payment.svg";
// Components
import IconDropdown from "../../../../../components/Dropdowns/IconDropdown";
import ClearFilter from "../../../../../components/ClearFilter/ClearFilter";
import TableSkeleton from "../../../../../components/Skeletons/TableSkeleton";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import PurchaseFilter from "./PurchaseFilter";
//Hooks
import { useSelector } from "react-redux";
import {
  base64ToBlob,
  base64ToPdfAndOpen,
} from "../../../../../components/CommonFunctions/CommonFunctions";
// Styles
import styles from "./PurchaseHistory.module.css";
import PaymentLinkDialog from "./PaymentLinkDialog";
import { useDispatch } from "react-redux";

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  lineHeight: "18px",
  backgroundColor: "#073E53",
  color: "#FFFFFF",
  textTransform: "capitalize",
  fontWeight: "400",
  fontSize: 14,
  padding: theme.spacing(1),
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  fontSize: "13px",
  color: "#142C44",
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "10px",
}));

function PurchaseHistory(props: any) {
  const { GetPurchaseHistoryData, UpdatePaymentLink } = props;
  const dispatch = useDispatch();
  const auth = useAuthUser();
  const [isDownloading, setIsDownloading] = useState(false);
  const authUser = auth();
  const instituteDetails = useSelector(
    (state: any) => state.institute.instituteDetails
  );
  const { purchaseHistory, purchaseHistoryLoading } = useSelector(
    (state: any) => state.appSettings
  );
  const { paymentlink } = useSelector((state: any) => state.appSettings);

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [isPaginating, setIsPaginating] = React.useState(false);

  // Main History Data
  const [purchaseHistoryData, setPurchaseHistoryData] = useState<any>({
    returnData: [],
    lastEvaluatedKey: null,
  });
  // For Dialog to show payment link
  const [paymentLinkPopup, setPaymentLinkPopup] = useState(false);
  const [paymentLink, setPaymentLink] = useState("");
  // for resend link
  const [dataTogetLink, setDataTogetLink] = useState({});
  //Scrolling
  const [hasMoreData, setHasMoreData] = useState(true);

  //Filters
  const [filteredPurchaseHistoryData, setFilteredPurchaseHistoryData] =
    useState<any[]>([]);
  const [filterApplied, setFilterApplied] = React.useState<boolean>(false);
  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([]);

  const filteredValue = (
    <>
      {selectedStatuses?.length > 0 &&
        selectedStatuses?.map((item) => (
          <div key={item} className="filteredDiv">
            {item}
          </div>
        ))}
    </>
  );

  function getFormattedDate(date: any) {
    return moment(date).format("DD MMM YYYY");
  }

  // ClearFilters
  const closeClearFilter = () => {
    setIsOpenFilter(false);
  };

  const cancelClick = () => {
    setIsOpenFilter(true);
  };

  const noButtonClick = () => {
    setIsOpenFilter(false);
  };
  const yesButtonClick = () => {
    /* 		setSelectedStatuses([]);
		setFilterApplied(false);
		setFilteredPurchaseHistoryData(purchaseHistoryData?.returnData); */
    handleResetClick();
    setIsOpenFilter(false);
  };

  const handleFilterChange = (status: string) => {
    setSelectedStatuses((prev) => {
      const normalizedStatus = status.toLowerCase();
      if (prev.includes(normalizedStatus)) {
        return prev.filter((item) => item !== normalizedStatus);
      } else {
        return [...prev, normalizedStatus];
      }
    });
  };

  const downloadInvoice = (id: string) => {
    DownloadPurchaseHistoryInvoice(id)
      .then((res: any) => {
        dispatch(
          setToastNotification({
            message: "Congratulations! Report is successfully downloaded.",
            type: "success",
            snackOpen: true,
          })
        );
        const base64ToPdf = res?.data?.data;

        if (!base64ToPdf) {
          throw new Error("No PDF data found.");
        }
        base64ToPdfAndOpen(base64ToPdf)
          .then((blob: any) => {
            const url = window.URL.createObjectURL(blob);

            window.open(url, "_blank");
          })
          .catch((err: any) => {});
      })
      .catch((err: any) => {
        dispatch(
          setToastNotification({
            message: "Something went wrong. Can you please try again!.",
            type: "error",
            snackOpen: true,
          })
        );
      });
  };

  type Status = "COMPLETED" | "PENDING" | "FAILED";

  const getLink = (data: any) => {
    setDataTogetLink(data);
    UpdatePaymentLink(data);
    setPaymentLinkPopup(true);
  };

  const getOptions = (
    historyId: string,
    status: Status,
    transactionId: string,
    updatedById: string,
    updatedByName: string
  ) => {
    const data = {
      historyId,
      transactionId,
      type: "copy",
      updatedById,
      updatedByName,
    };
    const label =
      status === "COMPLETED"
        ? "Download Invoice"
        : status === "PENDING"
        ? "Copy Payment Link"
        : "Resend Link";

    const onClick = () => {
      if (status === "COMPLETED") {
        downloadInvoice(historyId);
      } else if (status === "PENDING") {
        getLink(data);
      } else {
        const resend = { ...data, type: "update" };
        getLink(resend);
      }
    };
    const icon =
      status === "COMPLETED"
        ? download
        : status === "PENDING"
        ? copyPayment
        : resend;
    const options = [{ label, onClick, icon }];
    return options;
  };

  const handleClosePopup = () => {
    setPaymentLinkPopup(false);
    setPaymentLink("");
    setDataTogetLink({});
  };

  const getDetails = () => {
    const data = {
      instituteId: authUser?.institute?.[0]?.instituteId,
      limit: 10,
    };
    GetPurchaseHistoryData(data);
  };
  const handleResend = () => {
    setPaymentLinkPopup(false);
    setPaymentLink("");
    setTimeout(() => {
      getLink(dataTogetLink);
    }, 500);
  };

  const handleURLupdate = () => {
    const queryParams = new URLSearchParams();
    if (selectedStatuses.length) {
      queryParams.set("filtered", selectedStatuses.join("|"));
    } else {
      queryParams.delete("filtered");
    }
    const queryString = queryParams.toString();
    const newUrl = `${window.location.pathname}${
      queryString ? `?${queryString}` : ""
    }`;

    window.history.pushState({}, "", newUrl);
  };

  const handleApplyFilters = () => {
    setFilterApplied(true);
    if (selectedStatuses.length === 0) {
      setFilteredPurchaseHistoryData(purchaseHistoryData?.returnData);
      setHasMoreData(true);
    } else if (selectedStatuses.length) {
      const filteredData = purchaseHistoryData?.returnData.filter((item: any) =>
        selectedStatuses.includes(item.paymentStatus.toLowerCase())
      );
      setFilteredPurchaseHistoryData(filteredData);
      setHasMoreData(false);
      handleURLupdate();
    }
  };

  const downloadExcel = () => {
    const userFromLocalStorage = authUser?.institute[0];
    const id = userFromLocalStorage.instituteId;
    setIsDownloading(true);
    DownloadPurchaseHistoryReport(id)
      .then((res: any) => {
        const fileBase64String = res?.data?.data?.fileBase64String;

        if (!fileBase64String) {
          throw new Error("No file content received");
        }
        base64ToBlob(fileBase64String, "application/vnd.ms-excel")
          .then((blob: any) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `download.xlsx`;
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            dispatch(
              setToastNotification({
                message: "Congratulations! Report is successfully downloaded.",
                type: "success",
                snackOpen: true,
              })
            );
          })
          .catch((err: any) => {});
      })
      .catch((err: any) => {
        console.log("err", err);
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };
  const handleResetClick = () => {
    setSelectedStatuses([]);
    setFilteredPurchaseHistoryData(purchaseHistoryData?.returnData);
    setFilterApplied(false);
    setHasMoreData(true);
    const newUrl = window.location.pathname;
    window.history.pushState({}, "", newUrl);
  };

  const handleNextPage = () => {
    const userFromLocalStorage = authUser?.institute[0];
    const lastEvaluatedKey = purchaseHistoryData.lastEvaluatedKey;

    const id = userFromLocalStorage.instituteId;
    if (lastEvaluatedKey) {
      setIsPaginating(true);
      GetPurchaseHistory({
        instituteId: id,
        limit: 10,
        lastEvaluatedKey,
      })
        .then((res: any) => {
          const newData = res?.data?.data?.returnData || [];
          const newLastEvaluatedKey = res?.data?.data?.lastEvaluatedKey;
          if (
            newLastEvaluatedKey &&
            newLastEvaluatedKey !== purchaseHistoryData.lastEvaluatedKey
          ) {
            setHasMoreData(true);
          } else {
            setHasMoreData(false);
          }

          const updatedRaw = {
            returnData: [...purchaseHistoryData.returnData, ...newData],
            lastEvaluatedKey: newLastEvaluatedKey,
          };

          setPurchaseHistoryData(updatedRaw);
          setFilteredPurchaseHistoryData(updatedRaw?.returnData);

          /* 	setFilteredPurchaseHistoryData(
						handleApplyFilters(updatedRaw.returnData, selectedStatuses)
					); */
        })
        .catch((err: any) => {})
        .finally(() => {
          setIsPaginating(false);
        });
    }
  };

  const clearStatus = (status: string) => {
    setSelectedStatuses(
      selectedStatuses.filter((item: any) => item !== status)
    );
  };

  useEffect(() => {
    if (authUser) getDetails();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const statusParam = params.get("filtered");

    if (statusParam) {
      const statusesFromURL = statusParam
        .split("|")
        .map((s) => s.toLowerCase());
      setSelectedStatuses(statusesFromURL);
      setFilterApplied(true);
    }
  }, []);

  useEffect(() => {
    if (purchaseHistory) {
      setPurchaseHistoryData({
        returnData: purchaseHistory?.data.returnData || [],
        lastEvaluatedKey: purchaseHistory?.data.lastEvaluatedKey || null,
      });

      /* 	const filteredData = handleApplyFilters(
				purchaseHistory?.data?.returnData || [],
				selectedStatuses
			); */

      if (selectedStatuses.length) {
        const filtered = purchaseHistory?.data.returnData.filter((item: any) =>
          selectedStatuses.includes(item.paymentStatus.toLowerCase())
        );
        setFilteredPurchaseHistoryData(filtered);
        setHasMoreData(false);
      } else {
        setFilteredPurchaseHistoryData(purchaseHistory?.data.returnData || []);
        setHasMoreData(true);
      }
    }
  }, [purchaseHistory]);

  useEffect(() => {
    setPaymentLink(paymentlink);
  }, [paymentlink, paymentLinkPopup]);

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.pageTitleOptions}>
        <div className={styles.pageTitle}>Purchase History</div>
        <div className={styles.options}>
          <div>
            <Button
              variant="contained"
              sx={{
                display: "flex",
                gap: "4px",
              }}
              disabled={filteredPurchaseHistoryData.length <= 0}
              onClick={downloadExcel}
              startIcon={<DownloadIcon />}
            >
              {isDownloading ? (
                <CircularProgress size={25} color={"inherit"} />
              ) : (
                "Download"
              )}
            </Button>
          </div>

          <div>
            <PurchaseFilter
              selectedStatuses={selectedStatuses}
              handleFilterChange={handleFilterChange}
              handleResetClick={handleResetClick}
              handleApplyFilters={handleApplyFilters}
              appliedFilter={filterApplied}
              cancelClick={cancelClick}
              clearStatus={clearStatus}
            />

            <ClearFilter
              open={isOpenFilter}
              noButtonClick={noButtonClick}
              yesButtonClick={yesButtonClick}
              onClose={closeClearFilter}
              filteredValue={filteredValue}
            />
          </div>
        </div>
      </div>

      <div>
        {purchaseHistoryLoading ? (
          <TableSkeleton />
        ) : (
          <div
            style={{
              border: "1px solid #EAECF0",
              borderRadius: "8px",
              minHeight: "calc(100vh - 210px)",
              position: "relative",
              overflowY: "hidden",
              marginTop: "5px",
            }}
          >
            <TableContainer sx={{ borderRadius: "6px" }}>
              <InfiniteScroll
                dataLength={filteredPurchaseHistoryData.length ?? 0}
                next={handleNextPage}
                hasMore={hasMoreData}
                loader={
                  isPaginating ? (
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {<PuffLoader color="#36d7b7" />}
                    </Box>
                  ) : null
                }
                height={"calc(100vh - 215px)"}
              >
                <Table
                  sx={{
                    minWidth: 700,
                  }}
                >
                  <TableHead
                    sx={{
                      background: "#073E53",
                      position: "sticky",
                      top: 0,
                      zIndex: 999,
                    }}
                  >
                    <TableRow>
                      <StyledTableCellHead
                        sx={{ minWidth: 120, padding: "16px" }}
                      >
                        Name
                      </StyledTableCellHead>
                      <StyledTableCellHead sx={{ minWidth: 180 }}>
                        Date
                      </StyledTableCellHead>

                      <StyledTableCellHead sx={{ minWidth: 200 }}>
                        Volume
                      </StyledTableCellHead>

                      <StyledTableCellHead sx={{ minWidth: 160 }}>
                        Amount
                      </StyledTableCellHead>
                      <StyledTableCellHead sx={{ minWidth: 180 }}>
                        Status
                      </StyledTableCellHead>
                      <StyledTableCellHead sx={{ minWidth: 80 }}>
                        Options
                      </StyledTableCellHead>
                    </TableRow>
                  </TableHead>
                  <TableBody sx={{ background: "#fff" }}>
                    {filteredPurchaseHistoryData?.map(
                      (report: any, index: any) => (
                        <TableRow key={`${report.name}-${index}`}>
                          <StyledTableCellBody
                            sx={{
                              textTransform: "capitalize",
                              fontWeight: "500",
                            }}
                          >
                            {report?.name === "ADD_ON_CREDIT"
                              ? "Addon Credits"
                              : report?.name}
                          </StyledTableCellBody>
                          <StyledTableCellBody>
                            {getFormattedDate(report?.createdDate)}{" "}
                          </StyledTableCellBody>

                          <StyledTableCellBody>
                            {report?.numberOfBundles} bundles (500 each)
                          </StyledTableCellBody>
                          <StyledTableCellBody
                            sx={{ fontWeight: "700", fontFamily: "Roboto" }}
                          >
                            ₹ {report?.amount}
                          </StyledTableCellBody>
                          <StyledTableCellBody>
                            <div style={{ display: "flex", gap: "10px" }}>
                              <div>
                                {report?.paymentStatus === "COMPLETED" ? (
                                  <img src={successIcon} />
                                ) : report?.paymentStatus === "PENDING" ? (
                                  <img src={pendingIcon} />
                                ) : (
                                  <img src={failedIcon} />
                                )}
                              </div>
                              <div>{report?.paymentStatus}</div>
                            </div>
                          </StyledTableCellBody>
                          <StyledTableCellBody>
                            <IconDropdown
                              options={getOptions(
                                report?.id,
                                report?.paymentStatus,
                                report?.transactionId,
                                report?.updatedById,
                                report?.updatedByName
                              )}
                            />
                          </StyledTableCellBody>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
                {filteredPurchaseHistoryData?.length === 0 && (
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      textTransform: "capitalize",
                      color: " #667085",
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      justifyContent: "center",
                      marginTop: "18%",
                    }}
                  >
                    <div style={{ color: " #142C44" }}>
                      {!filterApplied
                        ? "No results found."
                        : "No results found. Try another filter"}
                    </div>
                  </div>
                )}
              </InfiniteScroll>
            </TableContainer>
            {/* {filteredPurchaseHistoryData.length > 0 ? (
              <></>
            ) : (
              <>
                {filteredPurchaseHistoryData?.length <= 0 &&
                filterApplied === false ? (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "absolute",
                      fontSize: "14px",
                      color: "#667085",
                      fontWeight: "600",
                    }}
                  >
                    No data Available
                  </div>
                ) : (
                  filterApplied === false && <TableSkeleton />
                )}
              </>
            )} */}
          </div>
        )}
      </div>
      {paymentLink && (
        <PaymentLinkDialog
          open={paymentLinkPopup}
          cancelButtonClick={handleClosePopup}
          data={paymentLink}
          /* 	data={dataTogetLink}
					getLink={handleResend} */
        />
      )}
    </div>
  );
}

export default PurchaseHistory;
